/**
 * Run by index.html before the app's own module, so Toado's own widget hears
 * what the app logs while it starts (TOADO-910).
 *
 * In production this only starts listening, in this module, before any of the
 * app's code has run: no loader, no launcher, no request. The widget itself is
 * put on the page by DogfoodWidget once auth says the person is staff, and its
 * loader keeps these listeners; for anyone else they are dropped, and what they
 * heard with them (Codex and z.ai, round 2: a launcher shown before the session
 * was known, and a listener started only once a script had loaded). A dev build
 * has the widget for everyone, so it puts the loader on the page as well.
 */
import { leavePageLogs } from '../../widget/src/capture/pageLogs';
import { injectDogfoodWidget, staffRemembered } from './features/widget/dogfoodLoader';

if (import.meta.env.DEV || staffRemembered()) leavePageLogs();
if (import.meta.env.DEV) injectDogfoodWidget();
